import styled from 'styled-components';
export var HiddenInputSkin = styled.input.attrs({
  tabIndex: -1
}).withConfig({
  displayName: "HiddenInputskin__HiddenInputSkin",
  componentId: "dv3ldg-0"
})(["margin:-1px;padding:0;width:1px;height:1px;position:absolute;clip:rect(0,0,0,0);"]);